export const chatsTour = {
  key: "chats",
  version: 1,
  getSteps: (t) => [
    {
      target: "body",
      content: t("Tour_Chats_Overview"),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="chats-sidebar"]',
      content: t("Tour_Chats_Sidebar"),
      placement: "right",
    },
    {
      target: '[data-tour="chats-search"]',
      content: t("Tour_Chats_Search"),
      placement: "bottom",
    },
    {
      target: '[data-tour="chats-new-collab"]',
      content: t("Tour_Chats_NewCollab"),
      placement: "bottom",
    },
    {
      target: '[data-tour="chats-list"]',
      content: t("Tour_Chats_List"),
      placement: "right",
    },
    {
      target: '[data-tour="chats-main"]',
      content: t("Tour_Chats_Main"),
      placement: "left",
    },
    {
      target: '[data-tour="chats-input"]',
      content: t("Tour_Chats_Input"),
      placement: "top",
    },
  ],
};
